import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 490 490",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 490 490\" id=\"icon-line\">\r\n<g id=\"icon-line_line_7_\">\r\n\t<polygon points=\"490,489.954 490,459.329 31.222,459.375 30.625,0 0,0.031 0.628,490 \t\" />\r\n\t<polygon points=\"184.822,213.502 94.555,343.306 119.698,360.793 192.693,255.857 336.446,353.397 438.29,183.597 480.43,212.201 \r\n\t\t490,80.85 371.451,138.241 412.902,166.37 326.845,309.879 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol